export default (duration = 300) =>
  new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, duration);
  });
